<template>
  <div id="app">
    <div class="page">
        <router-view/>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'App', 
  computed: mapState(['property']),
  mounted: function()
  {
      this.property.back = this.$route.query.back;
      this.property.padding = this.$route.query.padding;
      
      if(this.$route.query.full)
      {
        document.querySelector('.page').style.width = '100%';
      }

      if(this.$route.query.back === null || this.$route.query.back === undefined || this.$route.query.back === '')
      {
        this.property.back = true;
      }

      if(this.$route.query.padding === null || this.$route.query.padding === undefined || this.$route.query.padding === '')
      {
        this.property.padding = 0;
      }
  }
}
</script>

<style>
#app {
  font-family: "Spoqa Han Sans Neo", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page {
    width: 100%;
    background: var(--Gray-20, #FFF);

}
/* layout */
@media (min-width: 500px) {
    .page {
        width: 500px;    
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue